export default __webpack_public_path__ + "static/media/never.00f75b29.mp3";